import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretRightSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4.03546L10 8.03546L6 12.0355", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretRightSmall);
const Memo = memo(ForwardRef);
export default Memo;
